import React from "react";
import type { BaseProps } from "@purpur/common-types";
import c from "classnames/bind";

import styles from "./card-media.module.scss";

const cx = c.bind(styles);

export type CardMediaProps = BaseProps;

const rootClassName = "purpur-card-media";

export const CardMedia = ({
  ["data-testid"]: dataTestId = "purpur-card-media",
  className,
  children,
  ...props
}: CardMediaProps) => (
  <div {...props} className={cx([rootClassName, className])} data-testid={dataTestId}>
    {children}
  </div>
);
